import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { range } from '@/utils/range';

import { ScoreCell } from './Cells';
import { ScoresHeatmap } from './ScoresHeatmap';

export const StateOfNature = () => {
  const { t } = useTranslation();
  const mockData = useMemo(() => {
    return range(1, 5).map((seed) => {
      return {
        group: `Area ${seed}`,
        ...Object.fromEntries(range(1, 5).map((i) => [`Indicator ${i}`, Math.random()])),
      };
    });
  }, []);
  return <ScoresHeatmap title={t('shared.disclosure.labels.stateOfNature')} data={mockData} factCell={ScoreCell} />;
};
